export const environment = {
  production: true,
  buildId: '2742356443518791',
  configFile: 'config.json',
};
